export default "__VITE_ASSET__767a4c2a__"